import React from 'react'
import ReactDOM from 'react-dom'

import App from './assets/js/App'

ReactDOM.render(<App />, document.querySelector('#app'))
